<template>
  <div class="dashboard-action-plan">
    <div class="dashboard-action-plan__title">{{ boxTitle }}</div>
    <div class="dashboard-action-plan__content">
      <div class="dashboard-action-plan__featured-text">{{ boxFeaturedText }}</div>
      <a :href="boxLink" class="dashboard-action-plan__link" target="_blank">{{ boxLinkLabel }}</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'dashboard-action-plan',
  props: {
    boxTitle: {
      type: String,
      required: true,
    },
    boxFeaturedText: {
      type: String,
      required: true,
    },
    boxLink: {
      type: String,
      required: true,
    },
    boxLinkLabel: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.dashboard-action-plan {
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid var(--box-color);
  font-size: .875rem;
  text-align: center;
  &:not(:last-child) {
    margin-bottom: .5rem;
  }
  .dashboard-action-plan__title {
    background-color: var(--box-color);
    color: $white;
    padding: .25rem;
  }
  .dashboard-action-plan__content {
    padding: .625rem;
    font-weight: 600;
    .dashboard-action-plan__featured-text {
      font-size: 1.125rem;
      font-weight: 600;
      color: var(--box-color);
      margin: .25rem 0;
    }
    .dashboard-action-plan__link {
      color: inherit;
      font-size: .75rem;
      text-decoration: underline;
    }
  }
}

@include media-breakpoint-up(lg) {
  .dashboard-action-plan {
    flex-basis: 0;
    flex-grow: 1;
    font-size: 1rem;
    &:not(:last-child) {
      margin-bottom: 0;
      margin-right: 1rem;
    }
    .dashboard-action-plan__title { font-size: 1.125rem; }
    .dashboard-action-plan__content {
      .dashboard-action-plan__featured-text { font-size: 1.25rem; }
      .dashboard-action-plan__link { font-size: .875rem; }
    }
  }
}
</style>
